import { strapiImageGetters } from '~/utils/strapiImageGetters'
import type { StrapiKftBanner } from '~/composables/types/strapi/common'
import type { StrapiApiDefaultResponse } from '~/composables/types/strapi-api'

const buildBannersQuery = (locale: string, pagekey: string) => {
  const params = new URLSearchParams()

  params.set('locale', locale)
  params.set('filters[pagekey][$eq]', pagekey)

  for (const field of ['bgImage', 'bgImageMobile'] as const) {
    params.set(`populate[${field}][fields][0]`, 'url')
    params.set(`populate[${field}][fields][1]`, 'formats')
    params.set(`populate[${field}][fields][2]`, 'alternativeText')
  }

  params.set('populate[featuredMedia][fields][0]', 'title')
  params.set('populate[featuredMedia][fields][1]', 'url')
  params.set('populate[featuredMedia][populate][media][fields][0]', 'url')
  params.set('populate[featuredMedia][populate][media][fields][1]', 'formats')
  params.set(
    'populate[featuredMedia][populate][media][fields][2]',
    'alternativeText'
  )

  return params.toString()
}

export const useBannerFromStrapi = async (
  pagekey: string,
  defaults = {}
): any => {
  const { locale } = useI18n()
  const { data: bannerDetails, refresh: loadBanners } =
    await useStrapiSingleType<
      StrapiApiDefaultResponse<StrapiKftBanner[]>,
      StrapiKftBanner[]
    >(`banners?${buildBannersQuery(locale.value, pagekey)}`, {
      lazy: true,
      server: false,
      transform: (data) => {
        return data?.data || []
      },
      default: () => [],
    })

  const bannerData = computed(() => {
    const [bannerData = {}] = bannerDetails?.value || []
    return {
      ...defaults,
      ...(defaults?.subtitle ? { description: defaults.subtitle } : {}),
      ...bannerData,
      bgImg: strapiImageGetters.getImageUrl(bannerData?.bgImage),
      bgImageMobile: strapiImageGetters.getImageUrl(bannerData?.bgImageMobile),
      bannerFeaturedMedia: (bannerData?.featuredMedia || []).map((mb) => ({
        ...mb,
        src: strapiImageGetters.getImageUrl(mb?.media),
        text: mb.title || '',
        url: mb.url || '',
        alt: strapiImageGetters.getAlternativeText(mb.media),
      })),
    }
  })

  return {
    bannerData,
    bannerFeaturedMedia: bannerData?.value?.bannerFeaturedMedia || [],
    loadBanners,
  }
}
